import sanitizeHTML from 'sanitize-html';
export class View {
    constructor(container) {
        this.container = container;
    }
    setText(element, value) {
        if (element) {
            element.textContent = String(value);
        }
    }
    setHidden(element) {
        element.style.display = 'none';
    }
    setVisible(element) {
        element.style.removeProperty('display');
    }
    setImage(element, src, alt) {
        if (element) {
            element.src = src;
            if (alt) {
                element.alt = alt;
            }
        }
    }
    setInnerHTML(element, value) {
        element.innerHTML = sanitizeHTML(value);
    }
    toggleClass(element, className, force) {
        element.classList.toggle(className, force);
    }
    setDisabled(element, state) {
        if (element) {
            if (state) {
                element.setAttribute('disabled', 'disabled');
            }
            else {
                element.removeAttribute('disabled');
            }
        }
    }
    render(data) {
        Object.assign(this, data !== null && data !== void 0 ? data : {});
        return this.container;
    }
}
